export default {
  A: "#ccff10",
  R: "#1010ff",
  N: "#cc10ff",
  D: "#ff1010",
  C: "#ffff10",
  Q: "#ff10cc",
  E: "#ff1066",
  G: "#ff9910",
  H: "#1066ff",
  I: "#66ff10",
  L: "#33ff10",
  K: "#6610ff",
  M: "#10ff10",
  F: "#10ff66",
  P: "#ffcc10",
  S: "#ff3310",
  T: "#ff6610",
  W: "#10ccff",
  Y: "#10ffcc",
  V: "#99ff10",
  B: "#ffffff",
  X: "#ffffff",
  Z: "#ffffff"
};
